export const getInitialized = (state) => {
	return state.app.initialized
}